import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import { createI18n } from 'vue-i18n'
import ENG from './local/eng.json'
import BG from './local/bg.json'
import ALB from './local/alb.json'
import GER from './local/ger.json'
import HR from './local/hr.json'
import SLO from './local/slo.json'
import FR from './local/fr.json'
import './registerServiceWorker'

const i18n = createI18n({
    locale: localStorage.getItem('language'),
    messages:{
        ENG:ENG,
        BG:BG,
        ALB:ALB,
        GER:GER,
        HR:HR ,
        SLO:SLO,
        FR:FR
    }
  })



createApp(App).use(router).use(i18n).mount('#app')
